import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import './HelpSupport.css';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';

function HelpSupport() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 900);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <>
            <HomeNav />
            <div className="help-support-container">
                <h2 className="help-support-title">Help & Support – Astra Clean</h2>
                <p className="help-support-intro">
                    We're here to help! At <strong>Astra Clean</strong>, your satisfaction and peace of mind matter to us. 
                    Below you'll find answers to common questions and guidance on how to get support quickly and easily.
                </p>

                <div className="help-support-section">
                    <h3 className="help-support-section-title">📅 Booking & Scheduling</h3>
                    <p className="help-support-text">
                        Booking our cleaning services is simple and convenient. You can schedule an appointment through our website 
                        or official communication channels. We offer flexible scheduling to fit your busy lifestyle.
                    </p>
                    <p className="help-support-text">
                        Please note that due to our fast <strong>2-hour service response time</strong>, cancellations are not available. 
                        However, we are happy to help you reschedule your appointment if needed. Just contact us as soon as possible.
                    </p>
                </div>

                <div className="help-support-section">
                    <h3 className="help-support-section-title">💳 Payments</h3>
                    <p className="help-support-text">
                        We accept multiple payment methods for your convenience, including:
                    </p>
                    <ul className="help-support-list">
                        <li>Credit & Debit Cards</li>
                        <li>Bank Transfers</li>
                        <li>Digital Wallets</li>
                    </ul>
                    <p className="help-support-text">
                        All payments are secure and processed through trusted platforms.
                    </p>
                </div>

                <div className="help-support-section">
                    <h3 className="help-support-section-title">🧼 Service Satisfaction</h3>
                    <p className="help-support-text">
                        Your satisfaction is our top priority. If you are not completely satisfied with our service, please contact us 
                        within <strong>24 hours</strong> of your appointment. Our support team will review your concern and work quickly to make things right.
                    </p>
                </div>

                <div className="help-support-section">
                    <h3 className="help-support-section-title">🛠️ Services We Support</h3>
                    <p className="help-support-text">
                        We provide assistance for all our services, including:
                    </p>
                    <ul className="help-support-list">
                        <li>Residential Cleaning</li>
                        <li>Commercial Cleaning</li>
                        <li>Specialized Cleaning Services</li>
                    </ul>
                    <p className="help-support-text">
                        If you have specific requests or special instructions, feel free to let us know in advance.
                    </p>
                </div>

                <div className="help-support-section">
                    <h3 className="help-support-section-title">📞 Contact Support</h3>
                    <p className="help-support-text">
                        For help, questions, or service-related concerns, please reach out to us through our official contact channels. 
                        Our friendly support team is always ready to assist you.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default HelpSupport;
